// Ленивая загрузка GLightbox: динамический import библиотеки + её CSS.
// Грузится отдельным async-чанком (webpack cacheGroup `glightbox`) только при
// первом обращении — на страницах без галерей не качается вовсе.
// Возвращает Promise<GLightboxConstructor | null> (null — если чанк не загрузился).
let loader = null;

export function loadGLightbox() {
  if (!loader) {
    loader = Promise.all([import('glightbox'), import('glightbox/dist/css/glightbox.css')])
      .then(([mod]) => mod.default)
      .catch((err) => {
        loader = null; // разрешить повторную попытку
        console.warn('GLightbox: не удалось загрузить чанк', err);
        return null;
      });
  }
  return loader;
}
